<template>
  <div>
    <div>
      <p v-if="store.state.guestLogin.navigationSource === 'UpdateCommunication'">
        You need to have a verified email address on file before you can enroll in paperless communication. Please follow the prompts below to update / verify your email.
      </p>
      <p v-if="!store.state.guestLogin.createContact && !store.state.guestLogin.navigationSource">
        Below is your existing contact information. To update your contact information, please check the box against the contact that you want to update and click on 'Next'. 
        Office email and Cell phone will be used for Multi Factor Authentication (MFA) to login to your Online Customer Portal and will be verified. If this information has been verified earlier, 
        it will have a green check against it. 

        <span v-if="store.state.guestLogin.createContact">Please enter your contact information below and click on 'Next'. We will send you a login code to your new contact information.</span> <br />
        <span v-if="store.state.guestLogin.createContact">
          Login code will be valid for limited time. Enter the login code on the following screen and upon successful login code validation your contact information will be updated and you will be navigated
          to your RI DMV Online Customer profile. Your contact information will be used for future electronic Multi Factor Authentication (MFA).
        </span>
      </p>

      <!-- For isPaperOtpSent show MFA fields -->
      <div v-if="store.state.guestLogin.createContact">
        <div class="business-contact-section">
          <!-- Office Email -->
          <div class="user-info">
            <span class="user-email-heading">Office Email</span> 
            <div class="user-info-group">
              <div class="user-info-group-contact">
                <span for="officeEmail" class="user-info-email">
                  {{ businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.officeEmail ? businessInfo.businessPersonalInformation.officeEmail : 'No office email on file' }}
                </span>
                <img v-if="businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.isOfficeEmailVerified == true" 
                     class="verify-icon" src="static/verified-icon.png" alt="Office email is verified">
              </div>
              <div class="user-info-group-contact">
                <input type="checkbox" id="update/verifyOfficeEmailCreate" v-model="updateOfficeEmail" @change="errMsg=''">
                <label for="update/verifyOfficeEmailCreate">Update <span class="sep-class">/</span> Verify</label>
              </div>
            </div>
          </div>

          <!-- Cell Phone -->
          <div class="user-info">
            <div class="user-phone-header">
              <span class="user-phone-heading">Cell Phone</span>
              <span class="user-phone-details">(Message and data rates may apply)</span>
            </div>
            <div class="user-info-group">
              <div class="user-info-group-contact">
                <span for="cellPhone" class="user-info-email">
                  {{ businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.cellPhone ? businessInfo.businessPersonalInformation.cellPhone : 'No cell phone on file' }}
                </span>
                <img v-if="businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.isCellPhoneVerified === true" 
                     class="verify-icon" src="static/verified-icon.png" alt="Cell phone is verified">
              </div>
              <div class="user-info-group-contact">
                <input type="checkbox" id="update/verifyCellPhoneCreate" v-model="updateCellPhone" @change="errMsg=''" >
                <label for="update/verifyCellPhoneCreate">Update <span class="sep-class">/</span> Verify</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- For UpdateCommunication flow: show Office Email -->
      <div v-else-if="store.state.guestLogin.navigationSource === 'UpdateCommunication'">
        <div class="user-info">
          <span class="user-email-heading">Office Email</span> 
          <div class="user-info-group">
            <div class="user-info-group-contact">
              <span for="officeEmail" class="user-info-email">
                {{ businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.officeEmail ? businessInfo.businessPersonalInformation.officeEmail : 'No office email on file' }}
              </span>
              <img v-if="businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.isOfficeEmailVerified == true" 
                   class="verify-icon" src="static/verified-icon.png" alt="Office email is verified">
            </div>
            <div class="user-info-group-contact">
              <input type="checkbox" id="update/verifyOfficeEmailComm" v-model="updateOfficeEmail" @change="errMsg=''">
              <label for="update/verifyOfficeEmailComm">Update <span class="sep-class">/</span> Verify</label>
            </div>
          </div>
        </div>
      </div>

      <!-- For normal contact update: ALL fields -->
      <div v-else>
        <div class="business-contact-section">
          <!-- Contact Name -->
          <div class="user-info">
            <span class="user-email-heading">Contact Name</span> 
            <div class="user-info-group">
              <div class="user-info-group-contact">
                <span for="contactName" class="user-info-email">
                  {{ businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.contactPersonName ? businessInfo.businessPersonalInformation.contactPersonName : 'No contact name on file' }}
                </span>
              </div>
              <div class="user-info-group-contact">
                <input type="checkbox" id="update/verifyContactName" v-model="updateContactName" @change="errMsg=''">
                <label for="update/verifyContactName">Update <span class="sep-class">/</span> Verify</label>
              </div>
            </div>
          </div>

          <!-- Office Email -->
          <div class="user-info">
            <span class="user-email-heading">Office Email</span> 
            <div class="user-info-group">
              <div class="user-info-group-contact">
                <span for="officeEmail" class="user-info-email">
                  {{ businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.officeEmail ? businessInfo.businessPersonalInformation.officeEmail : 'No office email on file' }}</span>
                <img v-if="businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.isOfficeEmailVerified == true" class="verify-icon" src="static/verified-icon.png" alt="Office email is verified">
              </div>
              <div class="user-info-group-contact">
                <input type="checkbox" id="update/verifyOfficeEmail" v-model="updateOfficeEmail" @change="errMsg=''">
                <label for="update/verifyOfficeEmail">Update <span class="sep-class">/</span> Verify</label>
              </div>
            </div>
          </div>

          <!-- Cell Phone -->
          <div class="user-info">
            <div class="user-phone-header">
              <span class="user-phone-heading">Cell Phone</span><span class="user-phone-details">(Message and data rates may apply)</span>
            </div>
            <div class="user-info-group">
              <div class="user-info-group-contact">
                <span for="cellPhone" class="user-info-email">{{ businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.cellPhone ? businessInfo.businessPersonalInformation.cellPhone : 'No cell phone on file' }}</span>
                <img v-if="businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.isCellPhoneVerified === true" class="verify-icon" src="static/verified-icon.png" alt="Cell phone is verified">
              </div>
              <div class="user-info-group-contact">
                <input type="checkbox" id="update/verifyCellPhone" v-model="updateCellPhone" @change="errMsg=''">
                <label for="update/verifyCellPhone">Update <span class="sep-class">/</span> Verify</label>
              </div>
            </div>
          </div>

          <!-- Office Phone -->
          <div class="user-info">
            <div class="user-phone-header">
              <span class="user-phone-heading">Office Phone</span>
            </div>
            <div class="user-info-group">
              <div class="user-info-group-contact">
                <span for="officePhone" class="user-info-email">{{ businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.officePhone ? businessInfo.businessPersonalInformation.officePhone : 'No office phone on file' }}</span>
              </div>
              <div class="user-info-group-contact">
                <input type="checkbox" id="update/verifyOfficePhone" v-model="updateOfficePhone" @change="errMsg=''">
                <label for="update/verifyOfficePhone">Update <span class="sep-class">/</span> Verify</label>
              </div>
            </div>
          </div>

          <!-- Office Fax -->
          <div class="user-info">
            <div class="user-phone-header">
              <span class="user-phone-heading">Office Fax</span>
            </div>
            <div class="user-info-group">
              <div class="user-info-group-contact">
                <span for="officeFax" class="user-info-email">{{ businessInfo.businessPersonalInformation && businessInfo.businessPersonalInformation.officeFax ? businessInfo.businessPersonalInformation.officeFax : 'No office fax on file' }}</span>
              </div>
              <div class="user-info-group-contact">
                <input type="checkbox" id="update/verifyOfficeFax" v-model="updateOfficeFax" @change="errMsg=''">
                <label for="update/verifyOfficeFax">Update <span class="sep-class">/</span> Verify</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <p v-if="errMsg" class="err-msg">{{ errMsg }}</p>
    <p v-if="errMsg" class="sr-only">{{ errMsg }}</p>
    
    <BaseButtonGroup>
      <button type="button" @click="handleRouting('previous')">Previous</button>
      <button type="submit" class="app-btn-primary" @click="handleRouting('next')">  
        Next
      </button>
    </BaseButtonGroup>
  </div>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'; 
import { useStore } from 'vuex'; 
import { useRouter } from 'vue-router'; 
import * as COMMONS from '../../../store/_commons'; 
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';

// Data
const updateContactName = ref(false);
const updateOfficeEmail = ref(false); 
const updateCellPhone = ref(false); 
const updateOfficePhone = ref(false);
const updateOfficeFax = ref(false);
const errMsg = ref(''); 

// Vuex Store
const store = useStore(); 

// Vue Router 
const router = useRouter(); 

// Computed Properties 
const businessInfo = computed(() => store.getters[COMMONS.BUSINESS_PROFILE_INFO]);

const contactInfo = computed(() => store.state.guestLogin.loginUserDetails); 

// Lifecycle Hooks 
onMounted(() => { 
  window.scroll(0, 0);
  document.body.setAttribute("tabindex", "1");
  document.body.focus();
  document.body.removeAttribute("tabindex");
  document.getElementById("app").scrollTop = 0;
});

// Methods 
const getUpdateContact = (data) => {
  store.dispatch(COMMONS.GUEST_UPDATE_CONTACT, data);
};

const handleRouting = async (info) => {
  if (info === 'previous') {
    if (contactInfo.value?.isPaperOtpSent) {
      router.push({ path: '/guest-signin' });
    } else {
      router.push({ path: '/businessprofile' });
    }
    return;
  }

  if (info !== 'next') return;

  if (store.state.guestLogin.createContact) {
    const anyMfaFieldSelected = updateOfficeEmail.value || updateCellPhone.value;
    if (!anyMfaFieldSelected) {
      errMsg.value = 'Please select the contact information to update/verify';
      return;
    }
    getUpdateContact({
      contactPersonName: false,
      officeEmail: updateOfficeEmail.value,
      cellPhone: updateCellPhone.value,
      officePhone: false,
      officeFax: false
    });
    errMsg.value = '';
    return;
  }

  const anyFieldSelected = updateContactName.value || updateOfficeEmail.value || updateCellPhone.value || updateOfficePhone.value || updateOfficeFax.value;
  if (!anyFieldSelected) {
    errMsg.value = 'Please select the contact information to update/verify';
    return;
  }
  getUpdateContact({
    contactPersonName: updateContactName.value,
    officeEmail: updateOfficeEmail.value,
    cellPhone: updateCellPhone.value,
    officePhone: updateOfficePhone.value,
    officeFax: updateOfficeFax.value
  });
  errMsg.value = '';
};

onUnmounted(() => {
  // Optional: Only clear if you want the state to reset every time they leave the page
});
</script>

<style lang="scss" scoped>
.business-contact-section {
  margin-top: 1rem;
}

.user-info {
  margin-top: 2rem;
  h3 {
    color: #000;
  }
  .user-phone-header{
    display: flex;
    align-items: baseline;
    .user-phone-heading{
      font-weight: bold;
    }
    .user-phone-details{
      margin-left: 5px;
    }
  }
  .user-email-heading{
    font-weight: bold;
  }
  .user-info-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 3rem;
    .user-info-group-contact {
      width: 300px;
      padding: 20px 0;
      display: flex;
      .verify-icon {
        width: 50px;
        height: 20px;
        vertical-align: middle;
        margin-left: 5px;
      }
      .user-info-email{
        width: 90%;
        word-wrap: break-word;
      }
      .sep-class{
        margin: 0 3px 0 2px;
      }
    }

    @media (min-width: 355px) and (max-width: 700px) {
      margin-bottom: 15px;
      .user-info-group-contact {
        padding: 5px 0;
      }
    }
  }

  @media (min-width: 355px) and (max-width: 740px) {
    .user-phone-header{
      display: block;
      .user-phone-details{
        margin-left: 0px !important;
      }
    }
    .user-info-group {
      gap: 0rem;
    } 
  }
}

.err-msg{
  color: var(--ri-red);
}

button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
    margin-right: 1em;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>